/**
 * Route → help-topic map. The header Help button uses it to open the manual
 * on the page the user is looking at, and scripts/check_help_coverage.cjs
 * uses it at BUILD TIME: a route added to App.tsx without coverage here
 * FAILS the build — a new screen cannot ship without its manual entry.
 *
 * Entries are [path-prefix, topic-id]; the longest matching prefix wins.
 */
export const HELP_ROUTE_MAP: [string, string][] = [
  ['/', 'welcome'],
  ['/dashboard', 'dashboard'],

  ['/patients', 'patients'],
  ['/orders', 'orders'],
  ['/samples', 'samples'],
  ['/laboratory', 'lab-ops'],
  ['/laboratory/quality-control', 'qc'],
  ['/laboratory/analyzer-results', 'results'],
  ['/laboratory/hl7-master-detail', 'results'],  // old path, still redirects
  ['/results', 'results'],

  ['/devices', 'devices'],
  ['/inventory', 'inventory'],
  ['/inventory/purchase-orders', 'procurement'],
  ['/inventory/goods-receipts', 'procurement'],
  ['/inventory/purchase-invoices', 'procurement'],
  ['/inventory/supplier-payments', 'procurement'],
  ['/inventory/debit-notes', 'procurement'],
  ['/inventory/purchase-documents', 'procurement'],

  ['/footfall', 'footfall'],
  ['/billing', 'billing'],
  ['/document-studio', 'document-studio'],
  ['/core', 'core'],
  // Longest prefix wins, so these override the blanket '/core' entry and the
  // Help button opens the manual on the screen the user is actually looking at.
  ['/core/branding', 'branding'],
  ['/core/appearance', 'appearance'],
  ['/core/document-sequences', 'numbering'],
  ['/core/holidays', 'holidays'],
  ['/core/container-types', 'containers'],
  ['/core/audit-trail', 'settings-audit'],
  ['/users', 'users'],
  ['/support', 'support'],

  ['/help', 'intutor'],
]

/** Longest-prefix match; '/' only matches exactly. */
export function helpTopicForPath(pathname: string): string {
  let best: [string, string] | null = null
  for (const e of HELP_ROUTE_MAP) {
    const [prefix] = e
    const hit = prefix === '/'
      ? pathname === '/'
      : pathname === prefix || pathname.startsWith(`${prefix}/`) || pathname.startsWith(`${prefix}?`)
    if (hit && (!best || prefix.length > best[0].length)) best = e
  }
  return best ? best[1] : 'welcome'
}
